import React, { Component } from 'react';
import * as Config from './../config/Config';
import * as Common from './../helpers/Common';
import * as User from './../helpers/User';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/lib/react-responsive-modal.css';
const $=window.$;

class DatewiseComp extends Component {
	constructor(props) {
		super(props);

        this.state={ 
          scores : [],
          records : [],
          startDate: '',
            endDate : '',
          open: false,
          report:[],

        };
        this.getReports = this.getReports.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.getBack = this.getBack.bind(this);
	}	

  getReports(practice_id){
    this.setState({
       open: true
    })
    let learnerID = Common.getUserData("id", true);
     fetch(Config.domainUrl+'practice/practice-report', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization':'Bearer ' +Common.getTokenData()
          },
            body: JSON.stringify({
              learnerID:learnerID,
              practice_id:practice_id,
            })
          }).then((response) => response.json())
         .then((responseJson) => {
          if(responseJson.status != 0){
           this.setState({
              report : responseJson.report
           });
          }
      });
   
  }

  getBack(type){
    this.props.switchPanel(type);
  }

   onCloseModal(){
    this.setState({ open: false });
  };

  getDetails(){
    let learnerID = Common.getUserData("id", true);
    let pinNo = Common.getUserData("pinNo", true);
    let pinID = Common.getUserData("pinID", true);
    let corporateID = Common.getUserData("corporateID", true);
    let productID = Common.getUserData("productID", true);
    let start_date = this.state.startDate;
    let end_date = this.state.endDate;

    Common.reactLoader("show", "Please wait...");
        fetch(Config.domainUrl+'practice/practice-time', {
                  method: 'POST',
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer ' +Common.getTokenData()
                  },
                    body: JSON.stringify({
                      learnerID:learnerID,
                      pinNo:pinNo,
                      pinID:pinID,
                      corporateID:corporateID,
                      productID:productID,
                      start_date:start_date,
                      end_date:end_date
                    })
                  }).then((response) => response.json())
                 .then((responseJson) => {
                  Common.reactLoader("hide");
                  if(responseJson.status != 0){
                   this.setState({
                    scores:responseJson.scores,
                    records : responseJson.submitted_datas,
                   });
                  }

                  Common.downTabClose();
              });
  }

	componentDidMount() {
    this.getDetails();	

     $("#datestart").datepicker({
      dateFormat: 'yy-mm-dd' ,
      changeMonth: true,
      yearRange: "-10:+0",
      changeYear: true,
      onSelect:function(selected,evnt){
        $("#dateend").datepicker({
            minDate: selected,
            dateFormat: 'yy-mm-dd' ,
            changeMonth: true,
            yearRange: "-10:+0",
            changeYear: true,
            onSelect:function(date_select,evnt){
              this.setState({
                endDate: date_select
              });
              this.getDetails();
            }.bind(this)
          });


        this.setState({
          startDate: selected
        });
      }.bind(this)

    });


	}

	
		render() {
      const {open} = this.state;
      
      let date_from = "";
	     let scores = this.state.scores.map((score,i)=>{
          return(
              <tr key={`score_${i}`}>
                <td style={{color: 'rgb(0, 0, 0)', borderBottom: '1px solid rgb(17, 165, 74)', background: 'rgb(255, 255, 255) none repeat scroll 0px 0px'}}>
                  {score.submtted}</td>
                <td style={{color: 'rgb(0, 0, 0)', borderBottom: '1px solid rgb(17, 165, 74)', background: 'rgb(255, 255, 255) none repeat scroll 0px 0px'}}>
                  {score.rejected}</td>
                <td style={{color: 'rgb(0, 0, 0)', borderBottom: '1px solid rgb(17, 165, 74)', background: 'rgb(255, 255, 255) none repeat scroll 0px 0px'}}>
                  {score.score}</td>
              </tr>
            )
       })
      
       let records = this.state.records.map((record,k)=>{
          return(
              <tr key={`record_${k}`}>
                <td>{record.sno}</td>
                <td>{record.name}</td>
                <td>{record.date}</td>
                <td>{record.score}</td>
                <td><a nohref='true' onClick={()=>this.getReports(record.practice_id)}>View Report</a></td>
              </tr>
            )
       })

       let report_data = this.state.report.map((repo,l)=>{
         let value = l+1;
         let date =  (new Date(repo.created_date)).toLocaleString();
         return(
              <tr key={`repo_${l}`}>
                <td>{value}</td>
                <td>{repo.comment}</td>
                <td>{date}</td>
                <td>{repo.score}</td>
              </tr>
         )
       })



		return (
          <div className="main-inner practice fillter">
            <div className="border-box"> 
              <div className="title-bg date-pad">  
                  <table cellSpacing="0" cellPadding="0" border="0">
                    <tbody>
                      <tr>
                        <td rowSpan="2" className="headfill">Total</td>
                        <td><strong>Practice Submitted</strong></td>
                        <td><strong>Practice Rejected</strong></td>
                        <td><strong>Practice Score</strong></td>
                      </tr>
                      {(!scores)?<tr><td colSpan='4'>No Records Found</td></tr>:scores}
                    </tbody>
                  </table>
                  <a nohref="true" onClick={(e)=>this.getBack('PracticeNokia')}>Back to Practice Corner</a>  
              </div>
              <section id="semana-scroll-inner" className="scrollbar">
                    <section className="scrollbar">
                      <section className="track">
                          <section className="thumb"></section>
                      </section>
                    </section>
                    <section className="viewport">
                      <section className="overview">
                          <div className="inner-content"> 
                          <table className="bordernonetab" width="100%" cellSpacing="0" cellPadding="0" border="1">
                            <tbody>
                              <tr>
                                <td><label>Filter by Date wise :</label></td>
                                <td><input type="text" name="datestart" value={this.state.startDate} className="txtdob" id="datestart" / ></td>
                                <td><input type="text" name="dateend" value={this.state.endDate} className="txtdob" id="dateend" /></td>
                              </tr>
                            </tbody>
                          </table>
                          <div className='ovlscrll'>
                              {(this.state.startDate != "" && this.state.endDate != "" )?date_from = <div className='chartstatus' style={{textAlign: 'left'}}>
                                  Data shows :&nbsp; From  &nbsp;&nbsp;<span style={{color:'#000',fontStyle: 'italic'}}>{this.state.startDate}</span> &nbsp;&nbsp;To &nbsp;&nbsp;<span style={{color:'#000',fontStyle: 'italic'}}>{this.state.endDate}</span>
                              </div>:''}
                              <table width="100%" cellSpacing="0" cellPadding="0" border="1" style={{borderCollapse:'collapse', border: 'solid 1px #e5e5e5'}}>
                                <tbody>
                                      <tr>
                                          <th>S.No</th>
                                          <th>Practice Name</th>
                                          <th>Submitted Date</th>
                                          <th>Score</th>
                                          <th>Report Details</th>                    
                                      </tr>
                                      {(records.length>0)?records:<tr><td colSpan='5'>No Records Found</td></tr>}             
                                </tbody>
                              </table>      
                          </div>     
                          </div>
                      </section>
                    </section>
              </section>
            </div>
            <Modal open={open} onClose={this.onCloseModal} >
                 <div className="practice fillter">
                    <table width="100%" cellSpacing="0" cellPadding="0" border="1" style={{borderCollapse:'collapse', border: 'solid 1px #e5e5e5'}}>
                      <tbody>
                        <tr>
                          <th>S.No</th>
                          <th>Report as per learner</th>
                          <th>Submitted Date</th>
                          <th>Score</th>
                        </tr>
                        {(report_data.length>0)?report_data:<tr><td colSpan='4'>No Data</td></tr>}
                      </tbody>
                    </table>   
                  </div>
            </Modal>
          </div>
			);

		}
}

export default DatewiseComp;



// WEBPACK FOOTER //
// ./src/practice/DatewiseComp.js